/* eslint-disable @next/next/no-html-link-for-pages */
import Custom404 from "../../404"
import { PartnerPage } from "../../../components/PartnerPage"
import { partnerWebpageOverride } from "../../../components/partner-webpage/partner-webpage-override"
import { IPartnerWebpage } from "../../../lib/models"
import { getPartnerWebpage } from "../../../service"
import type { GetServerSidePropsContext } from "next"
import React from "react"

interface Props {
  businessClassificationId?: string
  partnerWebpage: IPartnerWebpage
}

const PartnerWebpage = ({
  businessClassificationId,
  partnerWebpage,
}: Props) => {
  if (
    !partnerWebpage ||
    !partnerWebpage.active ||
    !partnerWebpage.generic ||
    !partnerWebpage.cobrandedImageUrl ||
    !partnerWebpage.partnerName ||
    !partnerWebpage.license?.id
  )
    return <Custom404 />

  const _cobrandedImageUrl =
    partnerWebpageOverride[partnerWebpage.license?.name]?.cobrandedImageUrl ??
    partnerWebpage.cobrandedImageUrl
  return (
    <PartnerPage
      partner={partnerWebpage.partnerName}
      percentage={partnerWebpage.percentageSavings}
      license={partnerWebpage.license.id}
      businessClassificationId={businessClassificationId}
      cobrandedImageUrl={_cobrandedImageUrl}
    />
  )
}

export default PartnerWebpage

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { slug, businessClassificationId } = ctx.query
  console.log(ctx.query)

  const partnerSlug = slug ? decodeURIComponent(slug as string) : null

  if (partnerSlug) {
    try {
      const partnerWebpage = await getPartnerWebpage(partnerSlug)
      console.log("-->", partnerWebpage)
      return {
        props: {
          partnerWebpage,
          businessClassificationId: businessClassificationId
            ? decodeURIComponent(businessClassificationId as string)
            : null,
        },
      }
    } catch (error) {
      return {
        props: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          errors: error.message,
        },
      }
    }
  } else {
    return {
      props: {
        errors: "No slug found",
      },
    }
  }
}
